import DialogCustom from 'src/components/elements/DialogCustom/DialogCustom'
import {FormattedMessage} from 'react-intl'
import PrimaryButton from 'src/components/elements/Buttons/PrimaryButton/PrimaryButton'
import SecondaryButton from 'src/components/elements/Buttons/SecondaryButton/SecondaryButton'
import {useForm} from 'antd/lib/form/Form'
import {useEffect} from 'react'
import EnrollmentPatientForm from '../EnrollmentPatientForm/EnrollmentPatientForm'

type NewEnrollmentDialogProps = {
  request?: Record<string, any>;
  onSubmit: (values: any) => void;
  onClose: () => void;
};

const NewEnrollmentDialog: React.FC<NewEnrollmentDialogProps> = ({request, onSubmit, onClose}) => {
  const [form] = useForm()

  useEffect(() => {
    form.resetFields()
    if (request) {
      form.setFieldsValue(request)
    }
  }, [form, request])

  const body = (
    <EnrollmentPatientForm form={form} />
  )

  const footer = (
    <div style={{display: 'flex', width: '100%'}}>
      <PrimaryButton
        key='submit'
        onClick={() => {
          form.validateFields()
            .then((values) => onSubmit(values))
            .catch(() => {})
        }}
        type='submit'
      >
        <FormattedMessage id='save' />
      </PrimaryButton>
      <SecondaryButton onClick={onClose}>
        <FormattedMessage id='undo' />
      </SecondaryButton>
    </div>
  )

  return (
    <DialogCustom
      body={body}
      footer={footer}
      maxWidth='lg'
      onClose={onClose}
      title={{text: 'Attivazione paziente', format: false}}
    />
  )
}

export default NewEnrollmentDialog
